import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");

  const toggle = useCallback((next) => {
    setLang((prev) => (next ? next : prev === "en" ? "es" : "en"));
  }, []);

  const value = useMemo(
    () => ({
      lang,
      setLang: toggle,
      t: translations[lang],
    }),
    [lang, toggle]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
